import PageTitle from "../../components/PageTitle";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";
import PageContent from "../../components/PageContent";
import useApi from "../../hooks/ApiHook";
import { useEffect, useState } from "react";
import If from "../../components/If";
import Loading from "../../components/Loading";
import usePaginator from "../../hooks/PaginatorHook";
import { useNavigate, useSearchParams } from "react-router-dom";
import MovementDetailSidebar from "./MovementDetailSidebar";
import NewMovementSidebar from "./NewMovementSidebar";

export default function() {

    const api = useApi();
    const navigate = useNavigate();
    const [ movements, setMovements ] = useState([]);
    const [ loading, setLoading ] = useState(true);
    const { page, limit, setTotal, Paginator } = usePaginator();
    const [ searchParams, setSearchParams ] = useSearchParams();
    const [ addMovementVisible, setAddMovementVisible ] = useState(false);
    const [ selected, setSelected ] = useState();
    
    useEffect(() => {
        retrieveData();
    }, [page, limit]);

    const retrieveData = () => {
        setLoading(true);
        api.get(`movements?page=${page}&limit=${limit}`).then(({ data }) => {
            setMovements(data.data);
            setTotal(data.total);
            setSearchParams({ page, limit });
        }).finally(() => setLoading(false));
    }

    const actions = movement => (
        <>
            <Button icon="pi pi-eye" title="Visualizar" onClick={() => setSelected(movement)}/>
        </>
    );

    const titleButtons = (
        <form>
            <Button label="Adicionar movimentação" type="button" onClick={() => setAddMovementVisible(true)}/>
            {/* <Button label="Importar NFe" type="button" onClick={() => document.getElementById('file-input').click()} loading={loadingNfe}/> */}
            {/* <input id="file-input" type="file" name="name" className="hidden" onChange={uploadNfe} accept="text/xml"/> */}
        </form>
    );

    const typeColumn = ({ type }) => type === 'SALE' ? 'VENDA' : 'REMESSA';

    return (
        <div>
            <NewMovementSidebar 
                visible={addMovementVisible} 
                onHide={() => setAddMovementVisible(false)}
                onSuccess={retrieveData}/>
            <MovementDetailSidebar movementId={selected?.id} onHide={() => setSelected(undefined)}/>
            <PageTitle title="Movimentações" subtitle="Verifique as movimentações de entrada e saída de estoque" end={titleButtons}/>
            <PageContent>
                <If condition={loading}>
                    <Loading/>
                </If>
                <If condition={!loading}>
                    <DataTable value={movements} selectionMode="single" emptyMessage="Nada encontrado">
                        <Column body={typeColumn} header="Tipo"></Column>
                        <Column field="destiny.commercialName" header="Destino"></Column>
                        <Column field={m => new Date(m.at).toLocaleString()} header="Data/hora"></Column>
                        <Column body={actions} header="Ações" align='right'></Column>
                    </DataTable>
                    <Paginator/>
                </If>
            </PageContent>
        </div>
    );
}